import { A9Component } from '../../system';

import './styles.less';
import template from './index.html';

interface IScope extends angular.IScope {
    withoutAside: 'true' | 'false';
    dlgToggleLayout(): void;
    state: { collapsed: boolean };
}

@A9Component({
    selector: 'vertical-layout-framework',
    replace: true,
    transclude: {
        aside: 'aside',
        content: 'content'
    },
    scope: {
        state: '=',
        withoutAside: '<'
    },
    template() {
        return template;
    }
})
class VerticalLayoutFramework {
    constructor(
        protected $scope: IScope,
        protected $injector: angular.auto.IInjectorService,
        protected $rootScope: angular.IScope,
        protected $element: JQuery
    ) {
        this.initScope();
        this.initState();
        this.run();
    }

    private initScope() {
        const $scope = this.$scope;
        $scope.dlgToggleLayout = () => {
            $scope.state.collapsed = !$scope.state.collapsed;
            this.setupCollapsedStateClass();
            this.announceViewportResize();
        };
    }

    private initState(): void {
        const $scope = this.$scope;
        $scope.state = $scope.state || {
            collapsed: false
        };
        this.setupCollapsedStateClass();
    }

    private run() {
        const $scope = this.$scope;
        $scope.$watch('withoutAside', () => {
            this.$element[0].classList[$scope.withoutAside ? 'add' : 'remove']('state-without-aside');
            this.announceViewportResize();
        });
    }

    protected setupCollapsedStateClass(): void {
        this.$element[0].classList[this.$scope.state.collapsed ? 'add' : 'remove']('state-collapsed');
    }

    protected announceViewportResize() {
        window.setTimeout(() => {
            this.$scope.$parent.$broadcast('awl-viewport-resize');
        }, 100);
    }
}
